import { WebAudioSuper } from "./webaudio_super.js";

class WebAudioMediaSourceNode extends WebAudioSuper {
  namespace = "webaudio:mediaSourceNode";
}

const webAudioMediaSourceNode = new WebAudioMediaSourceNode();
export { webAudioMediaSourceNode, WebAudioMediaSourceNode };
